import { render } from "./ModelButtons.vue?vue&type=template&id=24c86f3c"
import script from "./ModelButtons.vue?vue&type=script&lang=js"
export * from "./ModelButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__